import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  computed,
  signal,
} from '@angular/core';
import { Invoice } from '../interfaces/dashboard.component';

@Component({
  selector: 'app-dashboard-patient-invoices',
  standalone: false,
  templateUrl: './dashboard-patient-invoices.html',
  styleUrl: './dashboard-patient-invoices.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DashboardPatientInvoicesComponent {
  @Input() invoices: Invoice[] = [];
  @Input() isEnabled = false;
  @Input() billingPeriod: 'today' | 'week' | 'month' = 'week';
  @Input() loading = false;

  @Output() periodChange = new EventEmitter<'today' | 'week' | 'month'>();
  @Output() toggleAccess = new EventEmitter<boolean>();
  @Output() invoiceClicked = new EventEmitter<Invoice>();

  readonly filteredInvoices = computed(() => {
    const period = this.billingPeriod;
    const now = new Date();
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    const invoices = this.invoices;
    if (period === 'today') {
      return invoices.filter((inv) => {
        if (!inv.rawDate) return false;
        const d = new Date(
          inv.rawDate.getFullYear(),
          inv.rawDate.getMonth(),
          inv.rawDate.getDate()
        );
        return d.getTime() === today.getTime();
      });
    }
    if (period === 'week') {
      const weekStart = new Date(today);
      weekStart.setDate(today.getDate() - 6);
      return invoices.filter((inv) => inv.rawDate && inv.rawDate >= weekStart);
    }
    const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
    return invoices.filter((inv) => inv.rawDate && inv.rawDate >= monthStart);
  });

  onPeriodChange(value: string): void {
    this.periodChange.emit(value as 'today' | 'week' | 'month');
  }
}
